import { Box, Typography } from '@mui/material';
import LockIcon from '../../assets/lockIcon.png';
import { ExplorePlansButton } from './ui/Button';

const UpgradeSubscriptionPrompt = ({ blockedFeature }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      sx={{
        height: '100%',
        borderRadius: '20px',
        overflow: 'hidden',
        paddingX: 1,
      }}>
      <Box sx={{ textAlign: 'center', marginBottom: 1.5 }}>
        <img src={LockIcon} alt="selectable" style={{ width: '40px', height: 'auto' }} />
      </Box>
      <Typography
        variant="h6"
        sx={{ fontWeight: 700, textAlign: 'center', fontSize: '15px', marginBottom: 1 }}>
        Upgrade to unlock full access
      </Typography>
      <Typography variant="body1" sx={{ textAlign: 'center', fontSize: '13px', marginBottom: 3 }}>
        This feature is not included in your subscription
      </Typography>
      <ExplorePlansButton
        blockedFeature={blockedFeature}
        trackEventName={TrackEvent.PULSE_USER_CLICKED_EXPLORE_PLANS}
        height={'38px'}
        width={'136px'}
        fontSize={'13px'}
      />
    </Box>
  );
};

export default UpgradeSubscriptionPrompt;
